function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var buttonBarStyle = function buttonBarStyle() {
  return {
    root: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      '&$stacked': {
        justifyContent: 'flex-start',
        flexDirection: 'column'
      },
      '&$alignedLeft': {
        justifyContent: 'flex-start'
      }
    },
    alignedLeft: {},
    autoAligning: _defineProperty({}, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
      justifyContent: 'flex-start'
    }),
    stacked: {}
  };
};